import { db } from "../../../config/firebase/firebase-config";
import { IParamProcedure } from "../../../redux/types/types";
import { IValidateFormalities } from "../form/IValidateFormalities";

// Eliminar trámite
export const deleteProcedureFirebase = async (
  idEntity: string,
  idProcedure: string
) => {
  try {
    await db
      .collection("Correspondence")
      .doc(idEntity)
      .collection("ParamProcedure")
      .doc(idProcedure)
      .delete();
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Agregar trámite
export const addOrUpdateProcedure = async (
  idEntity: string,
  procedure: IParamProcedure
) => {
  try {
    await db
      .collection("Correspondence")
      .doc(idEntity)
      .collection("ParamProcedure")
      .doc(procedure.id)
      .set(procedure, { merge: true });
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Cargar trámites
export const loadProcedures = async (idEntity: string) => {
  const proceduresSnap = await db
    .collection(`/Correspondence/${idEntity}/ParamProcedure`)
    .get();
  const procedures: any = [];

  proceduresSnap.forEach((snapChild) => {
    procedures.push({
      ...snapChild.data(),
    });
  });

  return procedures;
};

export const loadProcedureById = async (
  data: IValidateFormalities
): Promise<any | null> => {
  const snap = await db
    .collection("Correspondence")
    .doc(data.idEntity)
    .collection("ParamProcedure")
    .where("id", "==", data.idParamProcedure)
    .limit(1)
    .get();
  if (snap.empty) {
    return null;
  }
  let response: any;
  snap.forEach((doc) => {
    response = doc.data() as any;
  });
  return response;
};

export const loadProcedureByName = async (
  data: IValidateFormalities
): Promise<any | null> => {
  const snap = await db
    .collection("Correspondence")
    .doc(data.idEntity)
    .collection("ParamProcedure")
    .where("procedureName", "==", data.nameParamProcedure)
    .limit(1)
    .get();
  if (snap.empty) {
    return null;
  }
  let response: any;
  snap.forEach((doc) => {
    response = doc.data() as any;
  });
  return response;
};
